import * as core from '../../../../../../../core'

import { query } from './activities-table.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.conditions.widgets.activities-table',
    description: 'Monitoring Activities',
    name: 'Monitoring Activities',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
